<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="行业名称" prop="name" required>
        <el-input v-model="form.name" placeholder="请输入行业名称" v-trim/>
      </el-form-item>
      <el-form-item label="行业关键字" prop="keywords" required>
        <ListInput v-model="form.keywords" placeholder="请输入关键字"/>
      </el-form-item>
<!--      <el-form-item label="行业模块" prop="moduleIds" required>-->
<!--        <ModuleSelect placeholder="请选择行业模块" v-model="form.moduleIds" :modules.sync="modules"/>-->
<!--        <el-table :data="modules" stripe>-->
<!--          <el-table-column prop="name" label="模块名称"></el-table-column>-->
<!--          <el-table-column prop="remark" label="备注"></el-table-column>-->
<!--          <el-table-column prop="fixed" label="是否固定">-->
<!--            <el-switch slot-scope="{ row }" v-model="row.fixed"/>-->
<!--          </el-table-column>-->
<!--        </el-table>-->
<!--      </el-form-item>-->
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" maxlength="200" :show-word-limit="true" v-model="form.remark" placeholder="请输入备注" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
import ListInput from '@/components/common/ListInput'
export default {
  name: 'OperaIndustryWindow',
  extends: BaseOpera,
  components: { ListInput, GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        name: '',
        keywords: '',
        moduleIds: [],
        remark: ''
      },
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入行业名称' }
        ],
        keywords: [
          { required: true, message: '请输入行业关键字' }
        ],
        moduleIds: [
          { required: true, message: '请选择行业模块' }
        ]
      },
      // 模块列表
      modules: []
    }
  },
  methods: {
    /**
     * 打开窗口
     *
     * @param title 窗口标题
     * @param target 行对象（仅编辑需该参数）
     */
    open (title, target) {
      this.title = title
      this.visible = true
      this.form.moduleIds = []
      this.modules = []
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
          this.form[this.configData['field.id']] = null
        })
        return
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key]
        }
        this.modules = target.modules
        this.form.moduleIds = this.modules.map(item => item.id)
      })
    },
    /**
     * 确认（点击确认按钮后触发）
     */
    confirm () {
      const param = {
        id: this.form.id,
        name: this.form.name,
        keywords: this.form.keywords,
        modules: this.modules.map(item => {
          return {
            moduleId: item.id,
            fixed: item.fixed
          }
        }),
        remark: this.form.remark
      }
      if (this.form[this.configData['field.id']] == null || this.form[this.configData['field.id']] === '') {
        this.__confirmCreate(param)
        return
      }
      this.__confirmEdit(param)
    }
  },
  created () {
    this.config({
      api: '/industry/list',
      'field.id': 'id'
    })
  }
}
</script>
